import {
  normalizeHeaderFooterTypographySettings,
  type HeaderFooterTypographySettings,
} from '../../../lib/settings/header-footer-typography.schema';
import type { TypographyStyleSettings } from '../../../lib/settings/typography.schema';
import { buildTypographyRule } from '../../../lib/layout/typography-css';

export {
  buildStorefrontHeaderTypographyCss,
} from '../../../lib/layout/storefront-header-typography';

const FOOTER_TYPOGRAPHY_KEYS: readonly (keyof HeaderFooterTypographySettings)[] = [
  'footerBrandTitle',
  'footerDescription',
  'footerSectionTitle',
  'footerLink',
  'footerNewsletterTitle',
  'footerNewsletterBody',
  'footerNewsletterButton',
  'footerCopyright',
];

const HEADER_TYPOGRAPHY_KEYS: readonly (keyof HeaderFooterTypographySettings)[] = [
  'brandTitle',
  'headerMenuRoot',
  'headerMenuChild',
  'headerSearchText',
  'headerAccountLabel',
  'headerCartAction',
  'topBarText',
];

export function isTypographyStyleConfigured(
  value: TypographyStyleSettings | null | undefined,
): boolean {
  return Boolean(
    (typeof value?.fontFamily === 'string' && value.fontFamily.trim()) ||
      typeof value?.fontSizePx === 'number' ||
      (typeof value?.color === 'string' && value.color.trim()),
  );
}

export function hasStorefrontHeaderTypographyOverrides(input: unknown): boolean {
  const typography = normalizeHeaderFooterTypographySettings(input);
  return HEADER_TYPOGRAPHY_KEYS.some((key) =>
    isTypographyStyleConfigured(typography[key]),
  );
}

export function hasStorefrontFooterTypographyOverrides(input: unknown): boolean {
  const typography = normalizeHeaderFooterTypographySettings(input);
  return FOOTER_TYPOGRAPHY_KEYS.some((key) =>
    isTypographyStyleConfigured(typography[key]),
  );
}

export function buildStorefrontFooterTypographyCss(input: unknown): string {
  const typography = normalizeHeaderFooterTypographySettings(input);
  return [
    buildTypographyRule('.footer-title--brand', typography.footerBrandTitle),
    buildTypographyRule('.footer-text', typography.footerDescription),
    buildTypographyRule(
      '.footer-section .footer-title:not(.footer-title--brand)',
      typography.footerSectionTitle,
    ),
    buildTypographyRule('.footer-link', typography.footerLink),
    buildTypographyRule('.footer-newsletter-title', typography.footerNewsletterTitle),
    buildTypographyRule('.footer-newsletter-text', typography.footerNewsletterBody),
    buildTypographyRule('.footer-newsletter-button', typography.footerNewsletterButton),
    buildTypographyRule('.footer-copyright', typography.footerCopyright),
  ]
    .filter(Boolean)
    .join('\n');
}
